<reports-menu> </reports-menu>

<hr>

<div class="alert alert-warning" role="alert" *ngIf="alert">
  {{ alert | translate}}
</div>

<h4>{{ 'LOGIN_ATTEMPS_SEARCH' | translate}}</h4>
<form [formGroup]="searchForm" (ngSubmit)="searchLoginAttemps()">
  <div class="row">

    <div class="form-group col-md-6">
      <label for="date">{{ 'DATE' | translate}}</label>
      <div class="input-group mb-3">

        <p-calendar #calendar class="form-control" name="date" formControlName="date"
          dateFormat="dd-mm-yy" [locale]="locale.localeObject"
          [inputStyle]="{'border':'none', 'font-size': '1em', 'padding': 'initial'}">
        </p-calendar> <button class="btn btn-outline-secondary fas fa-calendar-alt"
          (click)="calendar.showOverlay()" type="button"></button>


        <!--     <input class="form-control" name="date" ngbDatepicker #d="ngbDatepicker" name="date"
          formControlName="date">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary fas fa-calendar-alt" (click)="d.toggle()"
            type="button"></button>
        </div> -->
      </div>
    </div>


    <!--     <div class="form-group col-md-6">
      <label for="date">{{ 'DATE' | translate}}</label>
      <input type="number" class="form-control" id="date" formControlName="date">
    </div> -->
    <div class="form-group col-md-6">
      <label for="userName">{{ 'USERNAME_EMAIL' | translate}}</label>
      <input type="text" class="form-control" id="userName" formControlName="userName">
    </div>
  </div>

  <div class="form-group row margin-top">
    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-main-color btn-block">
        {{ 'SEARCH' | translate}}
      </button>
    </div>
    <div class="col-md-6">
      <button type="reset" class="btn btn-secondary-color btn-block">
        {{ 'RESET' | translate}}
      </button>
    </div>
  </div>
</form>


<!-- <div *ngIf="searchedLogingAttemps?.length">
  <table class="table">
    <thead class="thead-dark">
      <tr>
        <th scope="col">{{ 'HOST' | translate}}</th>
        <th scope="col">{{ 'USERNAME' | translate}}</th>
        <th scope="col">{{ 'DATE' | translate}}</th>
        <th scope="col">{{ 'SUCCESSFUL' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let logingAttemp of searchedLogingAttemps; let i = index">
        <td>{{logingAttemp.host}}</td>
        <td>{{logingAttemp.userName}}</td>
        <td>{{logingAttemp.date}}</td>
        <td><i class="fas fa-check-circle green" *ngIf="logingAttemp.successful == 1"> </i>
          <i class="fas fa-times-circle red" *ngIf="logingAttemp.successful != 1"> </i>
        </td>
      </tr>
    </tbody>
  </table>

</div> -->

<div class="text-center alert background-main-color" *ngIf="_resourceService.loading">
  <i class="fa fa-refresh fa-spin font-size-20"></i>
  <span> {{ 'LOADING' | translate }}...</span>
</div>

<div *ngIf="searchedLogingAttemps?.length && !_resourceService.loading">
  <p-table [value]="searchedLogingAttemps" sortField="date" [sortOrder]="-1" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="host">
          {{ 'HOST' | translate}}
          <p-sortIcon field="host"></p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="userName">
          {{ 'USERNAME' | translate}}
          <p-sortIcon field="userName"></p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="date">
          {{ 'DATE' | translate}}
          <p-sortIcon field="date"></p-sortIcon>
        </th>
        <th scope="col" pSortableColumn="successful">
          {{ 'SUCCESSFUL' | translate}}
          <p-sortIcon field="successful"></p-sortIcon>
        </th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-logingAttemp>
      <tr>
        <td>{{logingAttemp.host}}</td>
        <td>{{logingAttemp.userName}}</td>
        <td>{{logingAttemp.date}}</td>
        <td><i class="fas fa-check-circle green" *ngIf="logingAttemp.successful == 1"> </i>
          <i class="fas fa-times-circle red" *ngIf="logingAttemp.successful != 1"> </i>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>